const resources = {
    // Checkout
    'CHECKOUT.NEW_ADDRESS.MESSAGE':
        'Here you can add a new address to be included on this order receipt',
    'CHECKOUT.FOOTNOTE_MESSAGE':
        'Please note: For this order you will be charged in {currencyDisplayCode}. By placing an order, you agree to our <a href="javascript:void(0)" data-toggle="modal" data-target="#checkout-terms-modal">Terms & Conditions</a>.',
    'CHECKOUT.SUBMIT_BUTTON_CHARGE_ACCOUNT': 'Submit Order',
    'CHECKOUT.SUBMIT_BUTTON_DEFAULT': 'Process Payment',

    // Select Delivery Supplier Modal
    'SELECT_DELIVERY_SUPPLIER_MODAL.DELIVERY_ADDRESS_HEADING':
        'Select Your Delivery Address',
    'SELECT_DELIVERY_SUPPLIER_MODAL.DELIVERY_ADDRESS_DESCRIPTION':
        'Select from your previously used delivery addresses.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.RESELLER_HEADING': 'Select Your Reseller',
    'SELECT_DELIVERY_SUPPLIER_MODAL.RESELLER_DESCRIPTION':
        'Select from a list of your available Resellers from your delivery address set above.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.WHOLESALER_HEADING':
        'Select your Wholesaler',
    'SELECT_DELIVERY_SUPPLIER_MODAL.WHOLESALER_DESCRIPTION':
        'Select from a list of your available Wholesalers from your delivery address set above.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_DELIVERY_ADDRESS':
        'Add New Delivery Address',
    'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_RESELLER': 'Add new Reseller',
    'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_WHOLESALER': 'Add new Wholesaler',

    'SELECT_DELIVERY_SUPPLIER_MODAL.LOCKED_RESELLER_INFO':
        'Your Reseller is locked as you have selected their delivery address above.',
    'SELECT_DELIVERY_SUPPLIER_MODAL.LOCKED_WHOLESALER_INFO':
        'Your Wholesaler is locked as you have selected their delivery address above.',

    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_RESELLER_CONFIRMATION_HEADING':
        'Changing Reseller',
    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_RESELLER_CONFIRMATION_CONTENT':
        'Please note that changing your Reseller can affect your existing cart, pricing, and stock availability. Are you sure you want to proceed?',
    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_WHOLESALER_CONFIRMATION_HEADING':
        'Changing Wholesaler',
    'SELECT_DELIVERY_SUPPLIER_MODAL.CHANGE_WHOLESALER_CONFIRMATION_CONTENT':
        'Please note that changing your Wholesaler can affect your existing cart, pricing, and stock availability. Are you sure you want to proceed?',

    'REJECT_CUSTOMERS_MODAL.REJECT_CUSTOMERS_HEADING': 'Rejecting an Account',
    'REJECT_CUSTOMERS_MODAL.REJECT_CUSTOMERS_CONTENT':
        'Are you sure you want to reject this Reseller Account? This Reseller will be sent a notification and will not be able to order from you, or receive orders from their customers.',
    'REJECT_CUSTOMERS_MODAL.REJECT_CUSTOMERS_CONFIRM': 'Reject',

    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_HEADING': 'Rejecting an Order',
    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONTENT':
        'Are you sure you want to reject this order? Your customer will be sent a notification and the order will be cancelled.',
    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONFIRM': 'Reject',

    'PROCEED_WITHOUT_VALIDATION_MODAL.HEADING':
        'Proceed Without PIC Validation?',
    'PROCEED_WITHOUT_VALIDATION_MODAL.CONTENT':
        'I certify that the PIC information provided is true and correct along with all associated data to comply with each state and territory throughout Australia. By selecting I AGREE you thereby give permission for this data to be cross checked against state, territory and national databases for compliance purposes. In the event we are unable to verify the data a Leader Products representative will contact you.',
    'PROCEED_WITHOUT_VALIDATION_MODAL.CONFIRM': 'I AGREE',

    // Product List
    NO_PRODUCTS: 'No Products',

    // Product Filter
    'PRODUCT_LIST.FILTER': 'Filter:',
    SORT_BY: 'Sort By:',
    LIST_STYLE: 'List Style:',

    // Product Filter - Sort
    'SORT.RELEVANCE': 'Relevance',
    'SORT.DEFAULT': 'Default',
    'SORT.PRODUCT_NAME_ASC': 'Product Name (A-Z)',
    'SORT.PRODUCT_NAME_DESC': 'Product Name (Z-A)',
    'SORT.PRODUCT_CODE_ASC': 'Product Code (A-Z)',
    'SORT.PRODUCT_CODE_DESC': 'Product Code (Z-A)',
    'SORT.PRICE_ASC': 'Price Ascending',
    'SORT.PRICE_DESC': 'Price Descending',

    // Product Display
    'PRODUCT.DESCRIPTION_HEADING': 'Description',
    'PRODUCT.SPECIFICATION_HEADING': 'Specification',
    'PRODUCT.WIDTH': 'Width',
    'PRODUCT.HEIGHT': 'Height',
    'PRODUCT.DEPTH': 'Depth',
    'PRODUCT.WEIGHT': 'Weight',
    SIGN_IN_TO_ORDER: 'Sign in to order',
    ADD_TO_CART: 'Add to Cart',
    UPDATE_TO_CART: 'Update Cart',
    RETURN_TO_CART: 'Return to Cart',
    MIN_ORDER_QUANTITY_MOBILE: '* Min. Order Qty:',
    MIN_ORDER_QUANTITY_DESKTOP: '* Min. Order Quantity:',

    // In Store Product List
    REMOVE_CATEGORY: 'Remove Category',
    CREATE_NEW_CATEGORY: 'Create New Category',
    ADD_OR_REMOVE_CATEGORY: 'Add / Remove Category',
    NEW_PRODUCT: 'New Product',
    'PRODUCT_NAME:MOBILE': 'Name',

    // In Store Product Form
    PRODUCT_DETAILS: 'Product Details',
    PRODUCT_NAME: 'Product Name',
    PRODUCT_CODE: 'Product Code',
    YOUR_PRODUCTS: 'Your Products',
    'IN_STORE_PRODUCT_FORM:DELETE_MODAL:HEADING': 'Proceed with removal?',
    'IN_STORE_PRODUCT_FORM:DELETE_MODAL:SUBHEADING':
        'Are you sure you want to remove this product?',
    'IN_STORE_PRODUCT:REMOVE_PRODUCTS_SUCCESS_MESSAGE':
        '{total} product(s) have been removed',
    'IN_STORE_PRODUCT:NEW_CATEGORY_SUCCESS_MESSAGE':
        '{category_name} has been created',
    'IN_STORE_PRODUCT:REMOVE_CATEGORY_SUCCESS_MESSAGE':
        '{category_name} has been removed',

    // Customer Detail
    ORDER_HISTORY: 'Order History',
    ORDER_SUMMARY: 'Order Summary',

    // Coupon
    COUPON: 'Coupon',
    YOUR_COUPONS: 'Your Coupons',
    CREATE_COUPON: 'Create Coupon',
    COUPON_DETAILS: 'Coupon Details',
    GENERATE_COUPON_CODE: 'Generate Coupon Code',
    COUPON_CODE: 'Coupon code',
    COUPON_NAME: 'Coupon name',
    DISCOUNT_PERCENTAGE_ONLY: 'Discount (% only)',
    DISCOUNT: 'Discount',
    USAGE: 'Usage',
    SUB_LEVELS: 'Sub Levels',
    EXPIRY: 'Expiry',
    EXPIRY_DATE: 'Expiry date',
    EXTENDED: 'Extended',
    NON_EXTENDED: 'Non-Extended',
    'USAGE.SINGLE': 'Single',
    'USAGE.MULTIPLE': 'Multiple',
    'COUPON_TPYE.ORDER': 'Discount On Order',
    'COUPON_TPYE.PRODUCT': 'Discount On Product',

    // Referral Coupon
    REFERRAL_YOUR_COUPONS: 'Your Referral Coupons',
    REFERRAL_COUPON_Details: 'Referral Coupon Details',
    REFERRAL_COUPON_CODE: 'CODE',
    REFERRAL_COUPON_ASSIGNED_TO: 'ASSIGNED TO',
    REFERRAL_COUPON_WHOLESALER: 'WHOLESALER',
    REFERRAL_COUPON_DISCOUNT: 'DISCOUNT',
    REFERRAL_COUPON_PAYOUT: 'PAYOUT',
    REFERRAL_COUPON_EXPIRY: 'EXPIRY',
    REFERRAL_COUPON_SINGLE_USAGE: 'Single',
    REFERRAL_COUPON_MULTIPLE_USAGE: 'Multiple',

    // Cart
    'CART.ADD_TO_CART.SUCCESS_MESSAGE': 'Item(s) has been added to cart',
    'CART.UPDATE_CART_ITEM.SUCCESS_MESSAGE': 'Your item has been updated',
    CUSTOM_TAG: 'Custom Tag',
    REMOVE_ITEM_FROM_CART: 'Remove item from cart?',
    CART_NO_ITEMS: 'You have no items in your cart.',
    ORDER_NO_ITEMS: 'Order have no items.',
    ORDER_QUANTITY_REQUIRED: 'Qty Required',
    ORDER_QUANTITY_PICKED: 'Qty Picked',
    ORDER_QUANTITY_BO: 'B.O Qty',
    CONVERSION_RATE: 'Conversion Rate',
    WHOLESALE_BUY_PRICE: 'Wholesale Buy Price',
    WHOLESALE_BUY_PRICE_USD: 'Wholesale Buy Price USD',
    WHOLESALE_BUY_PRICE_AUD: 'Wholesale Buy Price AUD',
    WHOLESALE_ADJUSTABLE_RRP: 'Wholesale Adjustable RRP',
    WHOLESALE_ADJUSTABLE_RESELLER_PRICE: 'Wholesale Adjustable Reseller',
    WHOLESALE_ADJUSTABLE: 'Wholesale Adjustable',
    WHOLESALE_ADJUSTABLE_USD: 'Wholesale Adjustable USD',
    WHOLESALE_ADJUSTABLE_AUD: 'Wholesale Adjustable AUD',
    WHOLESALE_PRICE: 'Wholesale Price',
    WHOLESALE_PRICE_USD: 'Wholesale Price USD',
    RESELLER_BUY_PRICE: 'Reseller Buy Price',
    RESELLER_ADJUSTABLE_RRP: 'Reseller Adjustable RRP',
    RESELLER_ADJUSTABLE: 'Reseller Adjustable',
    RESELLER_ADJUSTABLE_AUD: 'Reseller Adjustable AUD',
    QUECLINK_COGS: 'Queclink COGS',
    QUECLINK_COGS_USD: 'Queclink COGS USD',
    QUECLINK_WHOLESALE_PRICE: 'Queclink Wholesale USD',
    QUECLINK_RESELLER_PRICE: 'Queclink Reseller',
    QUECLINK_RESELLER_PRICE_USD: 'Queclink Reseller USD',
    QUECLINK_RRP: 'Queclink RRP',
    LEADER_PRODUCTS_RRP: 'Leader Products RRP',
    RRP: 'RRP',
    RRP_INC_TAX: 'RRP Inc. Tax',
    RRP_USD: 'RRP USD',
    RRP_ADJUSTABLE: 'RRP Adjustable',
    RRP_ADJUSTABLE_AUD: 'RRP Adjustable AUD',
    BUY_PRICE: 'Buy Price',
    PROFIT: 'GM%',
    COGS: 'COGS',
    COGS_USD: 'COGS USD',
    RESELLER_PRICE: 'Reseller Price',
    RESELLER_PRICE_EX_TAX: 'Reseller Price Ex. Tax',
    RESELLER_PRICE_USD: 'Reseller Price USD',
    RETAIL_PRICE: 'Retail Price',
    SELL_PRICE_MIN: 'Sell Price (min)',
    SELL_PRICE_MAX: 'Sell Price (max)',
    CART: 'Cart',
    QTY: 'Qty',
    QUANTITY: 'Quantity',
    TAX: 'Tax',
    TOTAL: 'Total',
    SUBTOTAL: 'SUBTOTAL',
    SOH: 'SOH',
    WAREHOUSE_SOH: 'Warehouse SOH',
    WAREHOUSE_SOH_MIN: 'Warehouse SOH (min)',
    WAREHOUSE_SOH_MAX: 'Warehouse SOH (max)',
    CHECKOUT: 'Checkout',
    CONTINUE_SHOPPING: 'Continue Shopping',
    CUSTOM_TAG_TO_EDIT: 'Customised tag - click to edit',

    // Invoices
    PAYMENT_STATUS: 'Payment status',
    PAYMENT_DETAILS: 'Payment details',
    'INVOICE.INVOICE_NO': 'Invoice No.',
    'INVOICE.ORDER_NO': 'Order No.',
    'INVOICE.RESELLER_BUSINESS_NAME': 'Reseller',
    'INVOICE.WHOLESALER_BUSINESS_NAME': 'Wholesaler',
    'INVOICE.PLACED_ON': 'Placed on',
    'INVOICE.PAID_ON': 'Paid on',
    'INVOICE.PAID_AMOUNT': 'Total',
    'INVOICE.TOTAL_DUE': 'Total',
    'INVOICE.DUE_DATE': 'Due Date',
    'INVOICE.STATUS': 'Status',
    'INVOICE.SELECT': 'Select',

    // Reciprocal Invoices
    'RECIPROCAL_RECEIPTS.HEADING': 'Your Reciprocal Invoices',
    'RECIPROCAL_RECEIPTS.HEADING_US': 'Your Commission Statements',
    'RECIPROCAL_RECEIPTS.HEADING_CA': 'Your GST/HST Payment Statements',
    'RECIPROCAL_RECEIPTS.HEADING_NZ': 'Your Buyer Created Tax Invoice',

    // Receipts
    'RECEIPTS.HEADING': 'Your Receipts',

    // Manifest
    MANIFEST: 'Manifest',
    MANIFEST_LIST: 'Manifest List',
    MANIFEST_ID: 'Manifest ID',
    MANIFEST_STATUS: 'Manifest Status',
    PROCESSED: 'Processed',
    PRINTED: 'Printed',
    UNPRINTED: 'Unprinted',

    // Order
    ORDER_NUMBER: 'Order Number/ID',
    ORDER_NO: 'Order No.',
    ORDER_STATUS: 'Order Status',
    TRACKING_NUMBER: 'Tracking number',
    PAYMENT_TYPE: 'Payment type',
    PAYMENT_METHOD: 'Payment Method',
    TAGS: 'Tags',
    TAGS_YES: 'Yes',
    TAGS_NO: 'No',
    RESELLER: 'Reseller',
    SUPPLIER: 'Supplier',
    DATE_ORDERED: 'Date ordered',
    ORDERED: 'Ordered',
    DATE_PAID: 'Date Paid',
    PAID: 'Paid',
    YOUR_RECEIPTS: 'Your Receipts',
    ID: 'ID',
    Approval: 'Approve',
    REJECT: 'Reject',
    ORDER_APPROVAL: 'Order approval',
    SHIPPING_STATUS: 'Shipping Status',
    WHOLESALER: 'WHOLESALER',

    // Account Related
    PIC_NUMBERS: 'PIC Numbers',
    BUSINESS_NAME: 'Business Name',
    SKU: 'SKU',
    PurchaseOrderNumber: 'Purchase Order Number',
    PurchaseOrderNumberTooltipText:
        "A Purchase Order Number is a unique code for online purchases to authorize, track, and manage orders on websites. If you don't have one, please enter your name instead",
    NAME: 'Name',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    TOWN: 'Town',

    CURRENT_DELIVERY: 'Current Delivery',
    CURRENT_BILLING: 'Current Billing',

    // PIC Number
    ADD_NEW_PIC_NUMBER: 'Add new PIC number',

    COPY_REGISTRATION_URL: 'Copy Registration URL',
    REGISTRATION_URL_COPIED: 'Copied to Clipboard',

    // Fields
    'FIELD.ID': 'ID',
    'FIELD.PRODUCT': 'Product',
    'FIELD.DATE_FROM': 'Date (From)',
    'FIELD.DATE_UNTIL': 'Date (Until)',
    'FIELD.ORDER_STATUS': 'Order Status',
    'FIELD.PAYMENT_TYPE': 'Payment Type',
    'FIELD.SUPPLIER': 'Supplier',
    'FIELD.WHOLESALER': 'Wholesaler',
    'FIELD.RESELLER': 'Reseller',
    'FIELD.TOTAL_MIN': 'Total (Min)',
    'FIELD.TOTAL_MAX': 'Total (Max)',
    'FIELD.PRODUCT_CODE': 'Product Code',
    'FIELD.PRODUCT_NAME': 'Product Name',
    'FIELD.WAREHOUSE_SOH_MIN': 'Warehouse SOH (min)',
    'FIELD.WAREHOUSE_SOH_MAX': 'Warehouse SOH (max)',
    'FIELD.SELL_PRICE_MIN': 'Sell Price (min)',
    'FIELD.SELL_PRICE_MAX': 'Sell Price (max)',
    'FIELD.NAIT_NUMBER': 'NAIT Number',
    'FIELD.PIC_NUMBER': 'PIC Number',
    'FIELD.BUSINESS_NAME': 'Business Name',
    'FIELD.SKU': 'SKU',
    'FIELD.PurchaseOrderNumber': 'Purchase Order Number',
    'FIELD.TRADING_NAME': 'Trading Name',
    'FIELD.FIRST_NAME': 'First Name',
    'FIELD.LAST_NAME': 'Last Name',
    'FIELD.TOWN': 'Town',
    'FIELD.PHONE': 'Phone',
    'FIELD.FAX': 'FAX',
    'FIELD.MOBILE': 'Mobile Number',
    'FIELD.EMAIL': 'Email',
    'FIELD.EMAIL_CONFIRMATION': 'Confirm Email',
    'FIELD.WEBSITE': 'Website',
    'FIELD.ACCESS_CODE_TO_COPY_URL': 'Access Code To Copy Reg. URL',
    'FIELD.PASSWORD': 'Password',
    'FIELD.PASSWORD_CONFIRMATION': 'Confirm Password',
    'FIELD.NEW_PASSWORD': 'New Password',
    'FIELD.NEW_PASSWORD_CONFIRMATION': 'Confirm New Password',
    'FIELD.STRIPE_PUBLISHABLE_KEY': 'Stripe Publishable Key',
    'FIELD.STRIPE_SECRET_KEY': 'Stripe Secret Key',
    'FIELD.PAYFAST_PUBLISHABLE_KEY': 'PayFast Merchant Id',
    'FIELD.PAYFAST_SECRET_KEY': 'PayFast Secret Key',
    'FIELD.PAYFAST_PASS_PHRASE': 'PayFast Pass Phrase',
    'FIELD.CREATED_FROM': 'Join Date (From)',
    'FIELD.CREATED_UNTIL': 'Join Date (Until)',
    'FIELD.SELECT_CARD': 'Select Card',
    'FIELD.SAVE_CARD': 'Save This Card',
    'FIELD.OPERATOR_CODE': 'Operator Code',
    'FIELD.CREDIT_CARD': 'Credit Card',
    'FIELD.PAYFAST': 'PayFast',
    'FIELD.PAYFAST_CREDIT': 'Credit',
    'FIELD.CHARGE_ACCOUNT': 'Charge Account',
    'FIELD.BANK_TRANSFER': 'Bank Transfer',

    'FIELD.FIND_ADDRESS': 'Find Address',

    'FIELD.POSTMEN_CARRIER_NAME': 'CARRIER',
    'FIELD.POSTMEN_CARRIER_STATUS': 'STATUS',
    'FIELD.POSTMEN_CARRIER_STATUS_ACTIVE': 'Active',
    'FIELD.POSTMEN_CARRIER_STATUS_INACTIVE': 'Inactive',
    'FIELD.POSTMEN_CARRIER_EDIT': 'Carrier Edit',
    'FIELD.POSTMEN_CARRIER_DELETE': 'Carrier Delete',

    'FIELD.CARTRULE_TITLE': 'Title',
    'FIELD.CARTRULE_DISCOUNT': 'Discount',
    'FIELD.CARTRULE_MIN_AMOUNT': 'Spend',
    'FIELD.CARTRULE_ENABLED': 'Enabled',

    'FIELD.COUPON_CODE': 'Coupon Code',
    'FIELD.COUPON_NAME': 'Coupon Name',
    'FIELD.CUSTOMER_DISCOUNT': 'Customer Discount',
    'FIELD.PAYOUT_PERCENTAGE': 'Payout Percentage',
    'FIELD.PERCENTAGE_ONLY': 'Percentage only (I.e. 5%)',
    'FIELD.DISCOUNT_PERCENTAGE_ONLY': 'Discount (% only)',
    'FIELD.DISCOUNT': 'Discount',
    'FIELD.USAGE': 'Usage',
    'FIELD.TYPE': 'Type',
    'FIELD.EXPIRY': 'Expiry',
    'FIELD.EXPIRY_DATE': 'Expiry Date',
    'FIELD.EXTENDED_SUB_LEVELS': 'Extend to Sub-levels',
    'FIELD.ADD_NOTE': 'Add note',

    'FIELD.NZBN': 'NZBN',
    'FIELD.ABN': 'ABN',
    'FIELD.ACN': 'ACN',
    'FIELD.GST_NUMBER': 'GST Number',

    'FIELD.ORDER_NUMBER': 'Order Number/ID',
    'FIELD.INVOICE_NUMBER': 'Invoice Number/ID',
    'FIELD.SHIPPING_STATUS': 'Shipping Status',

    'FIELD.PLACEHOLDER.SELECT_LAZY_LETTER': '-- Select Lazy Letter --',
    'FIELD.PLACEHOLDER.SELECT_ADDRESS': '-- Select Address --',
    'FIELD.PLACEHOLDER.SELECT_RESELLER': '-- Select Reseller --',
    'FIELD.PLACEHOLDER.SELECT_WHOLESALER': '-- Select Wholesaler --',
    'FIELD.PLACEHOLDER.SELECT_ORDER_STATUS': '-- Select Order Status --',
    'FIELD.PLACEHOLDER.SELECT_SHIPPING_STATUS': '-- Select Shipping Status --',

    'FIELD.GROUP.PRODUCTS': 'Products',
    'FIELD.GROUP.USER_ADDRESSES': 'Your addresses',
    'FIELD.GROUP.RESELLER_ADDRESSES': 'Your reseller addresses',
    'FIELD.GROUP.WHOLESALER_ADDRESSES': 'Your wholesaler addresses',
    'FIELD.GROUP.BUSINESS_ADDRESSES': 'Your business addresses',

    'FIELD.GROUP.RECENTLY_USED_RESELLER': 'Assigned Resellers',
    'FIELD.GROUP.RECENTLY_USED_WHOLESALER': 'Assigned Wholesalers',
    'FIELD.GROUP.OTHER_RESELLER': 'Other Reseller',
    'FIELD.GROUP.OTHER_WHOLESALER': 'Other Wholesaler',

    'FILE_UPLOAD.DROP_FILE_HERE': 'Drop file here',
    'FILE_UPLOAD.DRAG_IMAGE_TO_UPLOAD': 'Drag Image to Upload',
    'FILE_UPLOAD.DRAG_DOCUMENT_TO_UPLOAD': 'Drag Document to Upload',
    'FILE_UPLOAD.BROWSE_YOUR_COMPUTER':
        'or, <span class="field__dropzone-explanation__highlight">browse</span> your computer',
    'FILE_UPLOAD.REPLACE_THIS_IMAGE': '<span>Replace</span> this image.',
    'FILE_UPLOAD.MAX_FILE_SIZE_INSTRUCTIONS':
        'Maximum file size: {maxSizeInMB} MB.',
    'FILE_UPLOAD.MAX_FILE_SIZE_EXCEEDED':
        'File is too large. The maximum size is: {size}',

    'FIELD.CREDIT_CARD_INFORMATION': 'Card Details',
    'FIELD.NAME_ON_CARD': 'Name On Card',
    'FIELD.CARD_NUMBER': 'Number',
    'FIELD.EXPIRY_MONTH_YEAR': 'Expiry',
    'FIELD.CVV': 'CVV',

    'FIELD.ORDER_ON_BEHALF_OF': 'Order On Behalf Of',

    'FIELD.REGISTERED_BUSINESS_NAME': 'Registered Business Name',
    'FIELD.REGISTERED_BUSINESS_NUMBER': 'Registered Business Number',
    'FIELD.REGISTERED_BUSINESS_NUMBER_SA': 'Registered VAT Number',
    'FIELD.ADDRESS_LINE_1': 'Unit / Apartment / Suite / Building',
    'FIELD.ADDRESS_LINE_2': 'Street Address / PO Box',
    'FIELD.ADDRESS_LINE_3': 'Address Line 3',
    'FIELD.SUBURB': 'City / Suburb',
    'FIELD.STATE': 'State / Province / Region',
    'FIELD.POSTCODE': 'Zip / Postal Code',
    'FIELD.COUNTRY': 'Country',
    'FIELD.SHIPPERS': 'Carriers',

    'FIELD.NOTES': 'Notes',
    'FIELD.NOTES.PLACEHOLDER': 'Write your note here',

    'FIELD.BILLING_ADDRESS': 'Billing Address',
    'FIELD.DISPATCH_LOCATION': 'Dispatch Location',
    'FIELD.DELIVERY_ADDRESS': 'Delivery Address',
    'FIELD.DISCOUNT_CODE': 'Discount Code',
    'FIELD.PURCHASE_ORDER_NUMBER': 'Purchase Order Number',
    'FIELD.PURCHASE_ORDER_NUMBER_TOOLTIP':
        "A Purchase Order Number is a unique code for online purchases to authorize, track, and manage orders on websites. If you don't have one, please enter your name instead",
    'FIELD.FREIGHT_DELIVERY_OPTION': 'Freight / Handling',
    'FIELD.DELIVERY_OPTION': 'Delivery Option',
    'FIELD.URGENT_DELIVERY_PRIORITISATION': 'Urgent delivery prioritisation',
    'FIELD.ADDITIONAL_DELIVERY_NOTES': 'Additional Delivery Notes',
    'FIELD.URGENT_DELIVERY_PRIORITISATION_WARNING':
        'Urgent delivery prioritization has not been implemented. Please confirm if we are doing this',
    'FIELD.APPLIED_DISCOUNT': 'Applied Discount',
    'FIELD.IS_REQUIRED': 'Field is required',
    'FIELD.SOMETHING_WRONG': 'Something wrong with the process',
    'FIELD.PLEASE_CONFIRM_DOING':
        'Please confirm if we are doing this on checkout',

    'FIELD.ACCOUNT_DEPT_CONTACT': 'Account Dept Contact Name',
    'FIELD.ACCOUNT_DEPT_EMAIL': 'Account Dept Email',
    'FIELD.ACCOUNT_DEPT_PHONE': 'Account Dept Phone',

    'FIELD.PURCHASE_DEPT_CONTACT': 'Purchasing Dept Contact Name',
    'FIELD.PURCHASE_DEPT_EMAIL': 'Purchasing Dept Email',
    'FIELD.PURCHASE_DEPT_PHONE': 'Purchasing Dept Phone',

    'FIELD.BSB': 'Swift Code',
    'FIELD.BSB_AU': 'BSB',
    'FIELD.BSB_CA': 'Routing Number',
    'FIELD.BANK_NAME': 'Bank Name',
    'FIELD.BANK_ACCOUNT_NAME': 'Account Name',
    'FIELD.BANK_ACCOUNT_NUMBER': 'Account Number',
    'FIELD.BANK_SWIFT_CODE': 'Bank Swift Code',
    'FIELD.BANK_SWIFT_CODE.TOOLTIP':
        'Swift Code is not required for Australian accounts.',

    'FIELD.SELECT_COUPON_USAGE': 'Select Usage',
    'FIELD.SELECT_PIC_NUMBER': 'Select PIC Number',
    'FIELD.SELECT_NAIT_NUMBER': 'Select NAIT Number',
    'FIELD.PREVIOUSLY_USED_NAIT': 'Previously Used NAIT',
    'FIELD.PREVIOUSLY_USED_PIC': 'Previously Used PIC',
    'FIELD.PROPERTY_NAME': 'Property Name',
    'FIELD.OWNER_NAME': 'Owner Name',
    'FIELD.CONTINUE_SEQUENCE': 'Continue Sequence?',
    'FIELD.USE_PREFIX': 'Use Prefix',
    'FIELD.USE_BRAND_NOT_PIC': 'Use Brand Not Pic',
    'FIELD.USE_BRAND_PIC': 'Use Brand and Pic',
    'FIELD.STEP': 'Increment Value',
    'FIELD.STEP.TOOLTIP':
        'The value added to your Starting Number per tag. For example, if you want tags numbered from 1 to 25, you increment by one (Increment Value).',
    'FIELD.PREFIX': 'Prefix',
    'FIELD.PREFIX.TOOLTIP':
        'This will add any character/s before your sequence number and will be fixed.',
    'FIELD.SUFFIX': 'Suffix',
    'FIELD.SUFFIX.TOOLTIP':
        'This will add any character/s after your sequence number and will be fixed.',

    'FIELD.PARTICIPANT_CODE': 'Participant Code',
    'FIELD.USE_DUPLICATE': 'This is a duplicate tag order',
    'FIELD.USE_PARTICIPANT_CODE': 'Use Participant Code',
    'FIELD.YEAR': 'Year',
    'FIELD.SELECT_DISEASE_CODE': 'Select Disease Code',
    'FIELD.SELECT_DISEASE_CODE_NONE': 'None',
    'FIELD.SELECT_PREFIX': 'Select Prefix',
    'FIELD.DISEASE_CODE': 'Disease Code',
    'FIELD.RESELLER_PURCHASE_ORDER': 'Reseller Purchase Order',
    'FIELD.APPROVED_ON': 'Approved On',
    'FIELD.REJECTED_ON': 'Rejected On',
    'FIELD.CONTACT_CUSTOMER_ON': 'Contact Customer On',
    'FIELD.BY': 'By',
    'FIELD.ON': 'On',
    'FIELD.OFF_SHIPPING_AVAILABLE': 'OFF SHIPPING AVAILABLE',
    'FIELD.COMBINED_TOTAL_NOT_EXCEED':
        'The combined total of the Customer Discount must not exceed',
    'FIELD.VALUE_HAS_TO_BE': 'Value has to be',
    'FIELD.BETWEEN': 'between',
    'FIELD.AND': 'and',
    'FIELD.AT_LEAST_THAN': 'at least than',
    'FIELD.OR_LESS': 'or less',
    'FIELD.APPEARANCE': 'Appearance',
    'FIELD.CONTENT': 'Content',
    'FIELD.UPLOAD_IMAGE': 'Upload Image',
    'FIELD.ONLY_SVG_WARNING': 'Only *.svg files will be accepted',
    'FIELD.POSITION_OPTIONS': 'Position options',
    'FIELD.SNAP_CENTER': 'Snap Center',
    'FIELD.OBJECT_RULES': 'Object Rules',
    'FIELD.START_NUMBER': 'Start number',
    'FIELD.COUNT': 'Count',
    'FIELD.STEPS': 'Step',
    'FIELD.SEQUENCE_PREVIEW': 'Sequence Preview',
    'FIELD.COMBINED_DISCOUNT_TOTAL_NOT_EXCEED':
        'The combined total of the Customer Discount and Payout Percentage must not exceed',
    'FIELD.NO_STORES_MATCHING': 'No stores matching your criteria',
    'FIELD.FIND_NEAREST_STORE': 'Find Your Nearest Store and Supplier.',
    'FIELD.CHOOSE_OBJECT_TYPE': 'Choose object type',
    'FIELD.AWAITING_UPSTREAM_APPROVAL': 'Awaiting Upstream Approval',
    'FIELD.DECLINED': 'Declined',
    'FIELD.INCLUDE_BLANK': 'Include Blank',

    'FIELD.DAF_AUTHORISATION_NUMBER': 'DAF Number',
    'FIELD.DAF_AUTHORISATION_NUMBER.TOOLTIP':
        'The DAF authorisation number is for single use only. Your order cannot be processed without the required DAF authorisation number. If you do not have a DAF authorisation number, please tick the field below to authorise Leader Products to obtain for you.',
    'FIELD.DAF_AUTHORISATION_ISSUE_DATE': 'DAF Issue Date',
    'FIELD.CERTIFICATE_ISSUE_DATE': 'Certificate Issue Date',
    'FIELD.CERTIFICATE_QUANTITY': 'Certificate Quantity',
    'FIELD.CERTIFICATE_NUMBER': 'Certificate Number',

    'FIELD.CERTIFICATE_QUANTITY.TOOLTIP': 'The Certificate Quantity.',

    'FIELD.CERTIFICATE_NUMBER.TOOLTIP': 'The Certificate Number.',

    'FIELD.CERTIFICATE_ISSUE_DATE.TOOLTIP':
        'The Certificate date is the issue date on your Certificate form and is for single use only.',
    'FIELD.DAF_AUTHORISATION_ISSUE_DATE.TOOLTIP':
        'The DAF authorisation date is the issue date on your DAF authorisation form and is for single use only.',
    'FIELD.DAF_AUTHORISATION_CHECKBOX':
        'Please organise a DAF Authorisation for my order.',

    'FIELD.USE_BRAND_OVER_PIC': 'Use Brand Not PIC',
    'FIELD.BRAND': 'Brand',
    'FIELD.LAZY_LETTER': 'Lazy Letter',
    'FIELD.LAZY_LETTER.OPTIONS.0': '0 (None)',
    'FIELD.LAZY_LETTER.OPTIONS.1': '1 (First Character)',
    'FIELD.LAZY_LETTER.OPTIONS.2': '2 (Second Character)',
    'FIELD.LAZY_LETTER.OPTIONS.3': '3 (Arrow Middle Position)',
    'FIELD.LAZY_LETTER.OPTIONS.4':
        '4 Lazy First Character & Arrow Second Character',

    'FIELD.TASMANIA_ID_NUMBER': 'Tasmania ID Number',
    'FIELD.NAME_OF_PERSON_ORDERING': 'Name of Person Ordering',

    'FIELD.CUSTOM_FIELD': 'Custom Field',
    'FIELD.CURRENCY': 'Currency',

    'FIELD.MMT.INCLUDE_MMT': 'Include Matching Management Tag',
    'FIELD.MMT.MATCHING_TAG_SIZE': 'Matching tag size',
    'FIELD.MMT.COLOUR': 'Colour',
    'FIELD.MMT.MARKING_TYPE': 'Marking Type',
    'FIELD.MMT.PROPERTY_NAME': 'Property Name',
    'FIELD.MMT.VSPACETOOL': 'Lorem ipsum',
    'FIELD.MMT.MATCHING_MARKING': 'Matching Tag Marking',
    'FIELD.ADD': 'Add',
    'FIELD.ADD_LAYER_TYPE': 'Add Layer Type',
    'FIELD.TYPES_MESSAGE': 'You already have all types',
    'FIELD.CURVE_LAYER': 'Curve Layer',
    'FIELD.EXTRA_SETTINGS': 'Extra Settings',
    'FIELD.NLIS_LABEL': 'Show this as NLIS custom field',
    'FIELD.MAX_WIDTH': 'Max Width',
    'FIELD.POSITION': 'Position',
    'FIELD.BASIC_INFO': 'Basic Info',
    'FIELD.READ_ONLY_FIELD.LABEL': 'Layer ID',
    'FIELD.SCALING': 'Scaling',
    'FIELD.GODAREA_EXPLANATION':
        'Anything in this area is only available on SUPER ADMIN mode.',
    'FIELD.GODAREA_EXPLANATION_SEQUENCE_HINT':
        'If you need this sequence to be NLIS sequence, please use <strong>99999</strong> for starting number',
    'FIELD.GODAREA_EXPLANATION_LIST_HINT':
        'Please use this (custom list) if you need NAIT sequence or custom sequence, please use <strong>[[REPLACE_SEQUENCE]]</strong> for the content',
    DIMENSIONS: 'Dimensions',

    'FIELD.TEXT_CONTENT': 'Text Content',
    'FIELD.TEXT_CONTENT.TOOLTIP':
        'Type the text you want to appear on your tag in this field. (This field does not increment it is a fixed content field).',
    'FIELD.LINE_CONTENT': 'Line Content',
    'FIELD.LINE_CONTENT.TOOLTIP':
        'Type or paste a custom list into the field below. Each line will be marked on a separate tag.',
    'FIELD.LIST_CONTENT': 'Line Content (1 item per line)',
    'FIELD.LIST_CONTENT.ANIMATED_LABEL':
        'Copy from your source and paste in this text area',
    'FIELD.LIST_CONTENT.TOOLTIP':
        'Type or paste a custom list into the field below. Each line will be marked on a separate tag.',
    'FIELD.FONT': 'Font',
    'FIELD.SIZE': 'Size',
    'FIELD.SPACING': 'Spacing',
    'FIELD.LEADING_ZEROS': 'Leading Zeros',
    'FIELD.TEXT_ALIGNMENT': 'Text Alignment',
    'FIELD.STARTING_NUMBER': 'Starting Number',
    'FIELD.STARTING_NUMBER.TOOLTIP':
        'This is the first number in your sequence. If you want leading zeros enter them prior to your number e.g. if you want a 4 digit number starting at 1 type in 0001. You can choose to start from any number and it will increment on your tags relevant to your quantity.',
    'FIELD.USE_CUSTOM_LIST': 'Custom List',
    'FIELD.BARCODE_TYPE': 'Barcode Type',
    'FIELD.CODE_CONTENT': 'Code Content',

    // Field Postman
    'FIELD.POSTMAN.access_key': 'Access Key',
    'FIELD.POSTMAN.account': 'Account',
    'FIELD.POSTMAN.account_code': 'Account Code',
    'FIELD.POSTMAN.account_id': 'Account ID',
    'FIELD.POSTMAN.account_number': 'Account Number',
    'FIELD.POSTMAN.account_pin': 'Account Pin',
    'FIELD.POSTMAN.account_entity': 'Account Entity',
    'FIELD.POSTMAN.aes_key': 'AES Key',
    'FIELD.POSTMAN.agent_id': 'Agent ID',
    'FIELD.POSTMAN.agent_code': 'Agent Code',
    'FIELD.POSTMAN.application_id': 'Application ID',
    'FIELD.POSTMAN.application_token': 'Application Token',
    'FIELD.POSTMAN.api_customer_number': 'API Customer Number',
    'FIELD.POSTMAN.apikey': 'API Key',
    'FIELD.POSTMAN.api_key': 'API Key',
    'FIELD.POSTMAN.api_secret': 'API Secret',
    'FIELD.POSTMAN.api_token': 'API Token',
    'FIELD.POSTMAN.authorization_code': 'Authorization Code',
    'FIELD.POSTMAN.billing_account_id': 'Billing Account ID',
    'FIELD.POSTMAN.billing_register_number': 'Billing Register Number',
    'FIELD.POSTMAN.branch_code': 'Branch Code',
    'FIELD.POSTMAN.carrier_facility_id': 'Carrier Facility ID',
    'FIELD.POSTMAN.ccc': 'CCC',
    'FIELD.POSTMAN.check_word': 'Check Word',
    'FIELD.POSTMAN.ci': 'CI',
    'FIELD.POSTMAN.client_code': 'Client Code',
    'FIELD.POSTMAN.client_id': 'Client ID',
    'FIELD.POSTMAN.client_facility_id': 'Client Facility ID',
    'FIELD.POSTMAN.client_name': 'Client Name',
    'FIELD.POSTMAN.client_number': 'Client Number',
    'FIELD.POSTMAN.cod_customer_code': 'COD Customer Code',
    'FIELD.POSTMAN.company_id': 'Company ID',
    'FIELD.POSTMAN.consignorid': 'Consignor ID',
    'FIELD.POSTMAN.consignorname': 'Consignor Name',
    'FIELD.POSTMAN.contract_id': 'Contract ID',
    'FIELD.POSTMAN.contract_number': 'Contract Number',
    'FIELD.POSTMAN.cost_center': 'Cost Center',
    'FIELD.POSTMAN.currency': 'Currency',
    'FIELD.POSTMAN.customercode': 'Customer Code',
    'FIELD.POSTMAN.customer_code': 'Customer Code',
    'FIELD.POSTMAN.customer_number': 'Customer Number',
    'FIELD.POSTMAN.delis_user_id': 'Delis User ID',
    'FIELD.POSTMAN.developer_id': 'Developer ID',
    'FIELD.POSTMAN.developer_pin': 'Developer Pin',
    'FIELD.POSTMAN.dispatch_depot': 'Dispatch Depot',
    'FIELD.POSTMAN.ec_ship_username': 'EC Ship Username',
    'FIELD.POSTMAN.entity_id': 'Entity ID',
    'FIELD.POSTMAN.entity_pin': 'Entity Pin',
    'FIELD.POSTMAN.ftp_username': 'FTP Username',
    'FIELD.POSTMAN.ftp_password': 'FTP Password',
    'FIELD.POSTMAN.hmac_sha512_key': 'HMAC SHA512 Key',
    'FIELD.POSTMAN.hub_id': 'Hub ID',
    'FIELD.POSTMAN.identity': 'Identity',
    'FIELD.POSTMAN.key': 'Key',
    'FIELD.POSTMAN.key_password': 'Key Password',
    'FIELD.POSTMAN.labeller_code': 'Labeller Code',
    'FIELD.POSTMAN.language': 'Language',
    'FIELD.POSTMAN.licence_key': 'Licence Key',
    'FIELD.POSTMAN.license_key': 'License Key',
    'FIELD.POSTMAN.login_id': 'Login ID',
    'FIELD.POSTMAN.merchant_id': 'Merchant ID',
    'FIELD.POSTMAN.meter_number': 'Meter Number',
    'FIELD.POSTMAN.nif': 'NIF',
    'FIELD.POSTMAN.number_of_franchise': 'Number of Franchise',
    'FIELD.POSTMAN.origin_code': 'Origin Code',
    'FIELD.POSTMAN.partner_id': 'Partner ID',
    'FIELD.POSTMAN.partner_token': 'Partner Token',
    'FIELD.POSTMAN.password': 'Password',
    'FIELD.POSTMAN.passphrase': 'Pass Phrase',
    'FIELD.POSTMAN.pickup_account_id': 'Pickup Account ID',
    'FIELD.POSTMAN.pickup_name': 'Pickup Name',
    'FIELD.POSTMAN.prepaid_customer_code': 'Prepaid Customer Code',
    'FIELD.POSTMAN.ppi': 'PPI',
    'FIELD.POSTMAN.return_instructions': 'Return Instructions',
    'FIELD.POSTMAN.site_id': 'Site ID',
    'FIELD.POSTMAN.site_code': 'Site Code',
    'FIELD.POSTMAN.shipby_address_code': 'Ship By Address Code',
    'FIELD.POSTMAN.shipment_id_prefix': 'Shipment ID Prefix',
    'FIELD.POSTMAN.shipper_id': 'Shipper ID',
    'FIELD.POSTMAN.shipper_num': 'Shipper Number',
    'FIELD.POSTMAN.shipper_rate_plan': 'Shipper Rate Plan',
    'FIELD.POSTMAN.token': 'Token',
    'FIELD.POSTMAN.user_email': 'User Email',
    'FIELD.POSTMAN.user_identifier': 'User Identifier',
    'FIELD.POSTMAN.username': 'Username',
    'FIELD.POSTMAN.usps_endorsement': 'USPS Endorsement',

    'FIELD.POSTMAN.TrackingUrl': 'Tracking URL',
    'FIELD.POSTMAN.PriceConversionRate': 'Price Conversion Rate',
    'FIELD.POSTMAN.PriceConversionEnabled': 'Price Conversion Enabled',
    'FIELD.POSTMAN.Manifestable': 'Manifestable',
    'FIELD.POSTMAN.DangerousGoods': 'Dangerous Goods',

    // Default Stripe Label
    // Stripe - Bank Details
    'FIELD.STRIPE.StripeBSB': 'Swift Code',
    'FIELD.STRIPE.StripeBSB_US': 'Routing Number',
    'FIELD.PAYFAST.PayFastMerchantID': 'PayFast Merchant ID',
    'FIELD.PAYFAST.PayFastPassphrase': 'PayFast Pass phrase',
    'FIELD.STRIPE.StripeBankAccountHolderName': 'Account Holder Name',
    'FIELD.STRIPE.StripeBankAccountNumber': 'Account Number',
    'FIELD.STRIPE.StripeDOB': 'Date of Birth',
    'FIELD.STRIPE.StripeIdentityCardNumber': 'HKID Number',
    'FIELD.STRIPE.StripeCompany_BusinessName': 'Business Name',
    'FIELD.STRIPE.StripeCompany_TaxId': 'Business Number (Tax ID)',
    'FIELD.STRIPE.StripeFirstName': 'First Name',
    'FIELD.STRIPE.StripeSurname': 'Surname',
    'FIELD.STRIPE.StripeEmail': 'Email',
    'FIELD.STRIPE.StripePhone': 'Phone',
    'FIELD.STRIPE.StripeAddressStreetNumber': 'Company Street Number',
    'FIELD.STRIPE.StripeAddressSuburb': 'Company City / Suburb',
    'FIELD.STRIPE.StripeAddressState': 'Company State / Province / Region',
    'FIELD.STRIPE.StripeAddressPostalCode': 'Company Zip / Postal Code',
    'FIELD.STRIPE.StripeDocFront': 'Verification Document Front',
    'FIELD.STRIPE.StripeDocBack': 'Verification Document Back',
    'FIELD.STRIPE.StripeAdditionalDocFront': 'Additional Document Front',
    'FIELD.STRIPE.StripeAdditionalDocBack': 'Additional Document Back',

    'FIELD.STRIPE.StripeBusinessProfile_Mcc': 'Business Profile MCC',
    'FIELD.STRIPE.StripeBusinessProfile_Url': 'Business Profile URL',

    'FIELD.STRIPE.StripeCompany_Phone': 'Company Phone',
    'FIELD.STRIPE.StripeCompany_AddressStreetNumber': 'Company Street Number',
    'FIELD.STRIPE.StripeCompany_AddressSuburb': 'Company City / Suburb',
    'FIELD.STRIPE.StripeCompany_AddressState':
        'Company State / Province / Region',
    'FIELD.STRIPE.StripeCompany_AddressPostalCode': 'Company Zip / Postal Code',
    'FIELD.STRIPE.StripeCompany_DocFront':
        'Company Verification Document Front',
    'FIELD.STRIPE.StripeCompany_DocBack': 'Company Verification Document Back',

    // Representative Details
    'FIELD.STRIPE.StripeRepresentative_FirstName': 'Representative First Name',
    'FIELD.STRIPE.StripeRepresentative_Surname': 'Representative Last Name',
    'FIELD.STRIPE.StripeRepresentative_Gender': 'Representative Gender',
    'FIELD.STRIPE.StripeRepresentative_DOB': 'Representative Date of Birth',
    'FIELD.STRIPE.StripeRepresentative_Email': 'Representative Email',
    'FIELD.STRIPE.StripeRepresentative_Phone': 'Representative Phone',
    'FIELD.STRIPE.StripeRepresentative_IdentityCardNumber':
        'Representative Identity Card Number',
    'FIELD.STRIPE.StripeRepresentative_SSN':
        'Representative Social Security Number',
    'FIELD.STRIPE.StripeRepresentative_RelationshipTitle':
        'Representative Relationship Title',
    'FIELD.STRIPE.StripeRepresentative_AddressStreetNumber':
        'Representative Street Number',
    'FIELD.STRIPE.StripeRepresentative_AddressPostalCode':
        'Representative Zip / Postal Code',
    'FIELD.STRIPE.StripeRepresentative_AddressSuburb':
        'Representative City / Suburb',
    'FIELD.STRIPE.StripeRepresentative_State':
        'Representative State / Province / Region',
    'FIELD.STRIPE.StripeRepresentative_DocFront':
        'Representative Verification Document Front',
    'FIELD.STRIPE.StripeRepresentative_DocBack':
        'Representative Verification Document Back',
    'FIELD.STRIPE.StripeRepresentative_AdditionalDocFront':
        'Representative Additional Document Front',
    'FIELD.STRIPE.StripeRepresentative_AdditionalDocBack':
        'Representative Additional Document Back',

    // Director Details
    'FIELD.STRIPE.StripeDirector_FirstName': 'Director First Name',
    'FIELD.STRIPE.StripeDirector_Surname': 'Director Last Name',
    'FIELD.STRIPE.StripeDirector_Gender': 'Director Gender',
    'FIELD.STRIPE.StripeDirector_DOB': 'Director Date of Birth',
    'FIELD.STRIPE.StripeDirector_Email': 'Director Email',
    'FIELD.STRIPE.StripeDirector_Phone': 'Director Phone',
    'FIELD.STRIPE.StripeDirector_IdentityCardNumber':
        'Director Identity Card Number',
    'FIELD.STRIPE.StripeDirector_SSN': 'Director Social Security Number',
    'FIELD.STRIPE.StripeDirector_RelationshipTitle':
        'Director Relationship Title',
    'FIELD.STRIPE.StripeDirector_AddressStreetNumber': 'Director Street Number',
    'FIELD.STRIPE.StripeDirector_AddressPostalCode':
        'Director Zip / Postal Code',
    'FIELD.STRIPE.StripeDirector_AddressSuburb': 'Director City / Suburb',
    'FIELD.STRIPE.StripeDirector_State': 'Director State / Province / Region',
    'FIELD.STRIPE.StripeDirector_DocFront':
        'Director Verification Document Front',
    'FIELD.STRIPE.StripeDirector_DocBack':
        'Director Verification Document Back',
    'FIELD.STRIPE.StripeDirector_AdditionalDocFront':
        'Director Additional Document Front',
    'FIELD.STRIPE.StripeDirector_AdditionalDocBack':
        'Director Additional Document Back',

    // Owner Details
    'FIELD.STRIPE.StripeOwner_FirstName': 'Owner First Name',
    'FIELD.STRIPE.StripeOwner_Surname': 'Owner Last Name',
    'FIELD.STRIPE.StripeOwner_Gender': 'Owner Gender',
    'FIELD.STRIPE.StripeOwner_DOB': 'Owner Date of Birth',
    'FIELD.STRIPE.StripeOwner_Email': 'Owner Email',
    'FIELD.STRIPE.StripeOwner_Phone': 'Owner Phone',
    'FIELD.STRIPE.StripeOwner_IdentityCardNumber': 'Owner Identity Card Number',
    'FIELD.STRIPE.StripeOwner_SSN': 'Owner Social Security Number',
    'FIELD.STRIPE.StripeOwner_RelationshipTitle': 'Owner Relationship Title',
    'FIELD.STRIPE.StripeOwner_AddressStreetNumber': 'Owner Street Number',
    'FIELD.STRIPE.StripeOwner_AddressPostalCode': 'Owner Zip / Postal Code',
    'FIELD.STRIPE.StripeOwner_AddressSuburb': 'Owner City / Suburb',
    'FIELD.STRIPE.StripeOwner_State': 'Owner State / Province / Region',
    'FIELD.STRIPE.StripeOwner_DocFront': 'Owner Verification Document Front',
    'FIELD.STRIPE.StripeOwner_DocBack': 'Owner Verification Document Back',
    'FIELD.STRIPE.StripeOwner_AdditionalDocFront':
        'Owner Additional Document Front',
    'FIELD.STRIPE.StripeOwner_AdditionalDocBack':
        'Owner Additional Document Back',

    // AU Stripe Label
    'FIELD.STRIPE.StripeBSB.en_AU': 'BSB',
    'FIELD.STRIPE.StripeBankAccountNumber.en_AU': 'Bank Account Number',
    'FIELD.STRIPE.StripeCompany_TaxId.en_AU': 'ABN (Tax ID)',

    // CA Stripe Label
    'FIELD.STRIPE.StripeBSB.en_CA': 'Routing Number',
    'FIELD.STRIPE.StripeBankAccountNumber.en_CA': 'Account Number',
    'FIELD.STRIPE.StripeCompany_TaxId.en_CA': 'Business Number (Tax ID)',
    'FIELD.STRIPE.StripeBSB.StripeToolTip.en_CA':
        'ROUTING NUMBER FORMAT: 00000-000',
    'FIELD.STRIPE.StripeBankAccountNumber.StripeToolTip.en_CA':
        'ACCOUNT NUMBER FORMAT: 0000000',

    'STRIPE_CONNECT_FORM.SUCCESS.HEADING':
        'Your account payment configuration is validated',
    'PAYFAST_CONNECT_FORM.SUCCESS.CONTENT':
        'Your Payfast  profile has been completed. There is a chance they may require further verification in the future. You will be prompted here for additional details should this occur.',
    'STRIPE_CONNECT_FORM.SUCCESS.CONTENT':
        'Your Stripe Connect profile has been completed. There is a chance they may require further verification in the future. You will be prompted here for additional details should this occur.',
    'STRIPE_CONNECT_FORM.SUCCESS.EDIT_BANK.HEADING':
        'Your account payment configuration is validated',
    'STRIPE_CONNECT_FORM.SUCCESS.EDIT_BANK.SUBHEADING':
        'Bank Details: {countryCode}',
    'STRIPE_CONNECT_FORM.SUCCESS.EDIT_BANK.CONTENT':
        'Your account has been successfully verified and configured to receive payments. As we use Stripe Connect for payments, there is a chance they may require further verification in the future. You will be prompted here for additional details should this occur.',
    'STRIPE_CONNECT_FORM.WARNING.HEADING':
        'Your account is not configured to receive payments',
    'PAYFAST_CONNECT_FORM.WARNING.HEADING':
        'Your account requires additional verification to receive payments',
    'STRIPE_CONNECT_FORM.WARNING.SUBHEADING': 'Bank Details: {countryCode}',
    'STRIPE_CONNECT_FORM.WARNING.CONTENT':
        "Please enter the bank account details where you wish to receive automated payments from your Customers' online orders. This can be changed later after verification.",
    'PAYFAST_CONNECT_FORM.WARNING.CONTENT':
        'As we use PayFast for payments,it has been noted some additional verification information is required before you can receive payments. Please add your PayFast account credential below or create a new one & add here in order to finialize your configuration',
    'STRIPE_CONNECT_FORM.WARNING_STRIPE.HEADING':
        'Your account requires additional verification to receive payments',
    'STRIPE_CONNECT_FORM.WARNING_STRIPE.CONTENT':
        'As we use Stripe Connect for payments, it has been noted some additional verification information is required before you can receive payments. Please continue to Stripe and follow the prompts in order to finalise your configuration.',
    'STRIPE_CONNECT_FORM.WARNING_STRIPE.BUTTON': 'Continue to Stripe',
    'STRIPE_CONNECT_FORM.ERROR_TOKEN': 'Unable to get token',
    'STRIPE_CONNECT_FORM.ERROR_JS_LOADED': 'Stripe.js hasnt loaded yet.',
    'STRIPE_CONNECT_FORM.HAS_BEEN_PAID': 'has been paid successfully',
    'STRIPE_CONNECT_FORM.MANUAL_VERIFICATION': 'Manual Verification Required',
    'STRIPE_CONNECT_FORM.MARK_PAID': 'Marked as Paid',
    'STRIPE_CONNECT_FORM.TOTAL_OWING': 'Total Owing',
    'STRIPE_CONNECT_FORM.PAYING TODAY': 'PAYING TODAY',
    'STRIPE_CONNECT_FORM.USED_REFERENCE_MESSAGE':
        'I have used this reference number',

    'STRIPE_CONNECT_FORM.EMPTY_MESSAGE':
        'It seems that you do not have any Stripe Configuration that needs attention.',
    'STRIPE_CONNECT_FORM.BUSINESS_PROFILE.HEADING': 'Business Profile',
    'STRIPE_CONNECT_FORM.COMPANY.HEADING': 'Company',
    'STRIPE_CONNECT_FORM.REPRESENTATIVE.HEADING': 'Representative',
    'STRIPE_CONNECT_FORM.DIRECTOR.HEADING': 'Director',
    'STRIPE_CONNECT_FORM.OWNER.HEADING': 'Owner',

    'STRIPE_COUNTRY_FORM.HEADING':
        'Your account is not configured to receive payments',
    'STRIPE_COUNTRY_FORM.SUBHEADING': 'Select Country',
    'STRIPE_COUNTRY_FORM.CONTENT':
        'In order to receive payments, you need to complete your account setup with Stripe. Please start the process by selecting your country. Please note you can not change your country after saving.',

    'STRIPE_CONNECT_FORM.MISSING_FIELDS':
        'Your stripe still has missing fields. Please complete it to have your account activated.',
    'STRIPE_CONNECT_FORM.FIELDS_HEADING':
        'Please complete the following fields',
    'STRIPE_CONNECT_FORM.LETS_GO': 'Lets go',
    'STRIPE_CONNECT_FORM.SELECT_COUNTRY': 'Select a country',
    'STRIPE_CONNECT_FORM.SELECT_CURRENCY': 'Select a currency',

    'CREDIT_CARD_FORM.CURRENT_BILLING_ADDRESS': 'Your Current Billing Address',
    'CREDIT_CARD_FORM.NO_CURRENT_BILLING_ADDRESS':
        "You don't have a default billing address",

    'CHECKOUT.RECIPIENT_INFORMATION.CHANGE_DETAIL_CONTENT':
        'Edit your information in <a href="/account/details">Account Details</a>',

    'CHECKOUT.DISCOUNT_CODE.HEADING': 'Discount Code',

    'CHECKOUT.PURCHASE_ORDER_NUMBER.HEADING': 'Purchase Order Number',

    'CHECKOUT.BILLING_ADDRESS.HEADING': 'Billing Address',
    'CHECKOUT.DISPATCH_LOCATION.HEADING': 'Dispatch Location',
    'CHECKOUT.BILLING_ADDRESS.MESSAGE':
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.',

    'CHECKOUT.DELIVERY_ADDRESS.HEADING': 'Delivery Address',
    'CHECKOUT.DELIVERY_ADDRESS.MESSAGE':
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.',
    'CHECKOUT.DELIVERY_ADDRESS.NO_ADDRESS':
        "You don't have a selected delivery address",

    'PAYMENT_FORM.CREDIT_CARD.LOCKED_AMOUNT':
        'This order will be paid using the stored credit card data.',
    'PAYMENT_FORM.CREDIT_CARD.REQUIRE_CREDIT_CARD':
        'You will need to provide credit card details',
    'PAYMENT_FORM.CHARGE_ACCOUNT.HEADING':
        'This order will be added to your account.',
    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_WHOLESALER':
        'If you have account ID, please enter this here.',
    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_RESELLER':
        'If you have account ID, please enter this here.',
    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_CUSTOMER':
        'If you have account ID, please enter this here.',

    'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_BANK_TRANSFER':
        'After submitting your order, you will receive an email with Bank Transfer instructions. Your invoice can also be viewed at any time in the My Account > Invoices section.',

    'PAYMENT_FORM.PAYMENT_METHOD_WARNING':
        'You dont have any payment method available.',

    AWAITING_APPROVAL: 'Awaiting Approval',

    UNPACKED: 'Unpacked',
    PACKED: 'Packed',
    READY_FOR_COLLECTION: 'Ready for Collection',

    REGISTERED_CUSTOMERS: 'Registered Customers',
    REGISTERED_RESELLERS: 'Registered Resellers',
    EMAIL: 'Email',
    EMAIL_OR_USERNAME: 'Email / Username',
    REGISTERED: 'Registered',
    MEMBER_SINCE: 'Member Since',
    ACTION: 'Action',
    ADD_NEW_CUSTOMER: 'Add New Customer',
    ADD_NEW_RESELLER: 'Add New Reseller',
    APPROVE_REJECT: 'Approve / Reject',

    PROCESS_PAYMENT: 'Process Payment',
    PROCESS_PAYMENT_CARD: 'Process Payment',
    PROCESS_PAYMENT_BANK: 'Mark As Paid',
    PROCESS_PAYMENT_PAYFAST: 'Process Payment PayFast',

    PROCESS_PAYMENT_BANK_DESCRIPTION_DEFAULT:
        'Your order total is to be paid into the following account, the reference number must be included for your payment to be recognised.',
    PROCESS_PAYMENT_BANK_DESCRIPTION_SELECTED:
        'To pay an invoice via Bank Transfer you must first select an invoice from the list, then transfer the amount using the bank details and reference number provided, and the click "MARK AS PAID".',

    // Account Details Form
    'ACCOUNT_HOLDER_INFORMATION_FORM.HEADING': 'Account Holder Information',
    'ACCOUNT_HOLDER_IMP_INFORMATION_FORM.CONTENT':
        "For exisng users, please click LOGIN above.\n If this is your first me here, you'll need to create an account. This allows us to store your informaon, update you on order status, provide tracking details, send a copy of your invoice, and more. Please use a valid email address and remember your password for future logins.",
    'ACCOUNT_HOLDER_IMP_INFORMATION_FORM.HEADING': 'IMPORTANT',
    'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOMER_ID': 'Customer ID',
    'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOMER_EXO_ID': 'Account ID',
    'ACCOUNT_HOLDER_INFORMATION_FORM.CUSTOM_WEBSTORE_CODE':
        'Custom Webstore Code',
    'ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE':
        'Your information has been updated',
    'ACCOUNT_HOLDER_INFORMATION_FORM.SUCCESS_MESSAGE_EMAIL':
        'An email to confirm your email update has been sent',
    'ACCOUNT_ADDRESS.CONTENT.GUESTRESELLER':
        'Start typing to locate your address if you cannot find your address click on Enter address manually',
    'ACCOUNT_ADDRESS.HEADING': 'Your Delivery Addresses',
    'ACCOUNT_ADDRESS.CONTENT.CUSTOMER':
        'Here you can view a list of all your Delivery & Billing addresses. You can also add or remove an addresses, and set your preferred billing address.',
    'ACCOUNT_ADDRESS.CONTENT.RESELLER':
        'Here you can view a list of all your Delivery & Billing addresses. You can also add or remove an addresses, and set your preferred billing address.',
    'ACCOUNT_ADDRESS.CONTENT.WHOLESALER':
        'Here you can view a list of all your Delivery & Billing addresses. You can also add or remove an addresses, and set your preferred billing address.',
    'ACCOUNT_ADDRESS.ADD_NEW': 'Add New Address',

    'ACCOUNT_BUSINESS_ADDRESS.HEADING': 'Head Office Address',
    'ACCOUNT_BUSINESS_ADDRESS.CONTENT':
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam condimentum lorem in est sodales.',
    'ACCOUNT_BUSINESS_ADDRESS.HEADING.WHOLESALER': 'Dispatch Location Address',
    'ACCOUNT_BUSINESS_ADDRESS.CONTENT.WHOLESALER':
        'Please enter in the below address finder the address that you will use when dispatching your products to Resellers or Recommended Retail Customers. The address needs to be accurate as it will be used to automatically calculate freight pricing to your customers. If applicable you must also enter your unit / apartment / suite / building number etc.',
    'ACCOUNT_BUSINESS_ADDRESS.HEADING.RESELLER': 'Your Store Locator Details',
    'ACCOUNT_BUSINESS_ADDRESS.CONTENT.RESELLER':
        'Please enter in the below address finder the address that you wish to be displayed to a Recommended Retail Customer during their registration process for your Reseller store. If applicable you must also enter your unit / apartment / suite / building number etc.',

    'ACCOUNT_POSTMEN.HEADING': 'Shipping Carriers',
    'ACCOUNT_POSTMEN.CONTENT':
        'Here you can manage the shipping carriers available to all of your Resellers and Retail Customers. You have the ability to edit, delete, or add new carriers below.',
    'ACCOUNT_POSTMEN.ADD_NEW': 'Add New Carrier',
    'ACCOUNT_POSTMEN.SELECT_CARRIER': 'Select a carrier',

    'ACCOUNT_CARTRULE.HEADING': 'Shipping Discount',
    'ACCOUNT_CARTRULE.CONTENT': 'Cart Rule Description',
    'ACCOUNT_CARTRULE.ADD_NEW': 'Add New Shipping Discount',

    'ACCOUNT_EMAIL_FORM.HEADING': 'Change Email',

    'ACCOUNT_STRIPE_CREDENTIALS_FORM.HEADING': 'Stripe Credentials',
    'ACCOUNT_PAYFAST_CREDENTIALS_FORM.HEADING': 'PayFast Credentials',
    'ACCOUNT_STRIPE_CREDENTIALS_FORM.CONTENT':
        'You can change your stripe credentials by completing both fields below',
    'ACCOUNT_PAYFAST_CREDENTIALS_FORM.CONTENT':
        'You can change your PayFast credentials by completing both fields below',

    'ACCOUNT_PASSWORD_FORM.HEADING': 'Change Password',
    'ACCOUNT_PASSWORD_FORM.CONTENT':
        'You can change your password by completing both fields below',

    'ACCOUNT_RESELLER_ACCOUNT_DEPT_FORM.HEADING': 'Account Dept Information',
    'ACCOUNT_RESELLER_PURCHASE_DEPT_FORM.HEADING':
        'Purchasing Dept Information',

    'ACCOUNT_GOVERNMENT_DETAILS_FORM.HEADING':
        'Government Registration Details',

    'ACCOUNT_BANK_INFORMATION_FORM.HEADING': 'Bank Details',
    'ACCOUNT_BANK_INFORMATION_FORM.CONTENT.RESELLER':
        'The bank details below are shown to your customers for any order or invoice payments made via bank transfer. For the automatic Stripe payments, you will be prompted to enter further details on completion of your registration.',

    'ACCOUNT_PIC_NUMBER.HEADING':
        'NLIS Property Identification Code (PIC) Details',
    'ACCOUNT_PIC_NUMBER.CONTENT':
        'Here is a list of the PIC numbers you have previously used in the NLIS tag editor.',
    'ACCOUNT_PIC_NUMBER.ADD_NEW': 'Add PIC number',

    'ACCOUNT_BILLING_ADDRESS.HEADING': 'Billing Address',

    'ACCOUNT_CREDIT_CARD.HEADING': 'Saved Cards',
    'ACCOUNT_CREDIT_CARD.CONTENT':
        'Here you can manage all of your saved credit cards, and select the default to be used during the checkout process.',
    'ACCOUNT_CREDIT_CARD.ADD_NEW': 'Add New Card',

    'ACCOUNT_RESELLER.HEADING': 'Assigned Resellers',
    'ACCOUNT_RESELLER.CONTENT':
        'Here you can manage all of your nominated Resellers, and view the Assigned Account Number used when placing orders on Account.',
    'ACCOUNT_RESELLER.ADD_NEW': 'Add new Reseller',

    'ACCOUNT_WHOLESALER.HEADING': 'Assigned Wholesalers',
    'ACCOUNT_WHOLESALER.CONTENT':
        'You have the ability to change your Wholesaler below. [Please note this will affect the current range of stock available to your Retail Customers.]',
    'ACCOUNT_WHOLESALER.ADD_NEW': 'Add new Wholesaler',

    'ACCOUNT_QUECLINK.HEADING': 'Queclink Account',
    'ACCOUNT_QUECLINK.CONTENT':
        'Here you can view your Account Name and Assigned Account number for orders placed to Queclink.',
    'ACCOUNT_QUECLINK.ADD_NEW': 'Add new Reseller',

    'ACCOUNT_REFERRAL_COUPON.HEADING': 'Referral Coupons',
    'ACCOUNT_REFERRAL_COUPON.CONTENT': '',
    'ACCOUNT_REFERRAL_COUPON.ADD_NEW': 'Add New Coupon',

    'ACCOUNT_RESELLER_PAYMENT_METHODS_FORM.HEADING': 'Payment Options',
    'ACCOUNT_RESELLER_PAYMENT_METHODS_FORM.CONTENT':
        'Please select the payment options you wish to make available to your Retail Customers in the checkout.',

    ADD_NEW_ASSIGNED_WHOLESALER: 'Add new assigned Wholesaler',
    ADD_NEW_ASSIGNED_RESELLER: 'Add new assigned Reseller',
    ADD_NEW_ASSIGNED_SUPPLIER: 'Add new assigned Supplier',

    ASSIGNED_ACCOUNT_NUMBER: 'Assigned Account Number',
    ADD_NEW_ADDRESS: 'Add New Address',
    ADD_NEW_POSTMAN: 'Add New Carrier',
    ADD_NEW_CARTRULE: 'Add New Shipping Discount',
    EDIT_POSTMAN: 'Edit Carrier',
    EDIT_CARTRULE: 'Edit Cart Rule',
    ADD_NEW_BILLING_ADDRESS: 'Add New Billing Address',
    ADD_NEW_DELIVERY_ADDRESS: 'Add New Delivery Address',
    REGISTERED_BUSINESS_NAME: 'Registered Business Name',

    RESELLER_NAME: 'Account name',
    WHOLESALER_NAME: 'Wholesaler name',
    SUPPLIER_NAME: 'Supplier name',

    // Tag Wizard
    'TAG_WIZARD.EMPTY_PRODUCT.HEADING': 'This product is not available',
    'TAG_WIZARD.EMPTY_PRODUCT.CONTENT':
        'This product is not available in your region.',

    'TAG_WIZARD.TAG_USAGE.HEADING': 'Choose Tag Usage',
    'TAG_WIZARD.TAG_USAGE.NLIS': 'NLIS',
    'TAG_WIZARD.TAG_USAGE.NAIT': 'NAIT',
    'TAG_WIZARD.TAG_USAGE.TAG_EDITOR': 'Tag Editor',
    'TAG_WIZARD.TAG_USAGE.BLANK_TAG': 'Blank Tag',

    'TAG_WIZARD.TAG_COLOUR.HEADING': 'Colours',
    'TAG_WIZARD.TAG_COLOUR.COLOURS': 'Colours',
    'TAG_WIZARD.TAG_COLOUR.COLOUR': 'Colour',

    'TAG_WIZARD.TAG_PRODUCTION_TYPES.HEADING': 'Tag Production Types',
    'TAG_WIZARD.TAG_PRODUCTION_TYPES.OPTIONS.Beef': 'Beef',
    'TAG_WIZARD.TAG_PRODUCTION_TYPES.OPTIONS.Dairy': 'Dairy',

    'TAG_WIZARD.PRINTING_METHOD.HEADING': 'Marking Method',
    'TAG_WIZARD.PRINTING_METHOD.OPTIONS.Laser': 'Laser',
    'TAG_WIZARD.PRINTING_METHOD.OPTIONS.Foil': 'Foil',

    'TAG_WIZARD.PRINTING_METHOD.FOIL_ALERT':
        'Foil marking preview is an example only and fonts will be adjusted to the maximum available size where possible. Brand Lazy letters are not displayed but will be stamped according to your order details. Foil orders will be processed manually once submitted.',

    'TAG_WIZARD.PROPERTY.HEADING': 'Property Details',
    'TAG_WIZARD.PROPERTY.DESCRIPTION':
        'Enter your NLIS PIC details below so we can validate that your PIC, Property Name and Owner Name match the NLIS database. Details must be entered exactly the same as what is registered to the PIC in your state.',
    'TAG_WIZARD.PROPERTY.VALIDATE_BUTTON_TEXT': 'Validate details',
    'TAG_WIZARD.PROPERTY.FAILED_VALIDATION':
        'The PIC you have entered is incorrect. Please check your information and click retry.',
    'TAG_WIZARD.PROPERTY.FAILED_VALIDATION_PROCEED':
        'The PIC details you have entered have been validated, however the associated data does not match the information recorded in the NLIS database. Please check your information and click retry or proceed without validation.',
    'TAG_WIZARD.PROPERTY.NAIT_FAILED_VALIDATION':
        'The NAIT details you have entered are incorrect. Please check your information and click retry.',
    'TAG_WIZARD.PROPERTY.SUCCESSFUL_VALIDATION':
        'Details Successfully Validated',
    'TAG_WIZARD.PROPERTY.INACTIVE_VALIDATION':
        'Your PIC is showing as Disbanded, Inactive or Blocked please contact your relevant State Government Body for further details.',
    'TAG_WIZARD.PROPERTY.INACTIVE_VALIDATION_AU_ALTERNATIVE_BUTTON':
        'View Useful Links - Australia',

    'TAG_WIZARD.PROPERTY.NLIS.PIC_VIC_VALIDATION_WARNING':
        'All Electronic NLIS tags orders for VIC need to be processed through the VIC DPI.',
    'TAG_WIZARD.PROPERTY.NLIS.PIC_DPI_WARNING': 'Visit VIC DPI',
    'TAG_WIZARD.PROPERTY.NLIS.PIC_DPI_PROCEED': 'Proceed Without Validation',
    'TAG_WIZARD.PROPERTY.NLIS.STARTING_NUMBER_ISCOUNTINUES.DESCRIPTION':
        'Please enter the starting sequence number.',
    'TAG_WIZARD.PROPERTY.NLIS.STARTING_NUMBER.DESCRIPTION':
        'The number displayed in this field represents the first available number (e.g., 00001) or the next sequential number for tags previously ordered from Leader Products within the current year. NLIS identification numbers assigned by each tag manufacturer cannot be duplicated within the same year.',
    'TAG_WIZARD.PROPERTY.NLIS.PREFIX.DESCRIPTION':
        'An alphanumeric string that appears before your start number',

    'TAG_WIZARD.PROPERTY.NLIS.CHECKBOX.DESCRIPTION':
        'By ticking this box you are authorising Leader Products to obtain a DAF Authorisation Number on your/their behalf (Please note that this could delay the processing time of your order).',

    'TAG_WIZARD.PROPERTY.NLIS.BRAND.DESCRIPTION':
        'Enter your 3 digit brand to replace the PIC.',

    'TAG_WIZARD.PROPERTY.NLIS.LAZY_LETTER.DESCRIPTION':
        'To request a lazy letter, use the following codes: 0 = no lazy letter, 1 = lazy letter first position, 2 = lazy letter second position, 3 = an arrow will be used in the middle position. Please Note: Lazy letters will not be displayed in the tag preview on the next step.',

    'TAG_WIZARD.PROPERTY.NAIT.STARTING_NUMBER.ERROR.BIGGER_THAN_0':
        'Number needs to be bigger than 0',
    'TAG_WIZARD.PROPERTY.NAIT.STARTING_NUMBER.DESCRIPTION':
        'Enter the first number of the sequence number you require (E.G. 1 or 100).  If you require numbers that are not in a numerical sequence, please tick the Custom List and add in the individual numbers you wish to be reserved.',
    'TAG_WIZARD.PROPERTY.NAIT.PARTICIPANT_CODE.DESCRIPTION':
        'Enter your Participant Code here for it to be marked on the tag instead of your NAIT Number.',
    'TAG_WIZARD.PROPERTY.NAIT.YEAR.DESCRIPTION':
        'Enter the last two digits of the required year (E.G. Enter 22 for the year 2022)',
    'TAG_WIZARD.PROPERTY.NAIT.CUSTOM_LIST.DESCRIPTION':
        'Enter your individual Birth Tag ID number and the click on the + button to continue add further numbers you wish to be reserved.',

    'TAG_WIZARD.PROPERTY.NAIT.DESCRIPTION':
        'Enter your NAIT details below so we can validate your NAIT Number. Your NAIT Number, First and Last Name must be entered exactly the same as what is registered on the NAIT database.',

    'TAG_WIZARD.PROPERTY.NAIT.INVALID_SEQUENCE':
        'The following sequence number already exists in the NAIT database if you require a duplicate tag please check the box above otherwise select a different sequence number.',

    'TAG_WIZARD.APPEARANCE.TAG_APPEARANCE.HEADING': 'Tag Appearance',
    'TAG_WIZARD.APPEARANCE.LAYOUT_VARIATIONS.HEADING': 'Layout Variations',
    'TAG_WIZARD.APPEARANCE.MARKING_SIDES.HEADING': 'Marking Sides',
    'TAG_WIZARD.APPEARANCE.MARKING_SIDES.HEADING_TOOLTIP':
        'Available marking sides shown below',
    'TAG_WIZARD.APPEARANCE.TAG_DESIRED_LAYOUT_MESSAGE':
        'Select the desired layout variation from the options below',
    'TAG_WIZARD.APPEARANCE.SELECT_VARIATION': 'Select Variation',
    'TAG_WIZARD.APPEARANCE.CUSTOM_LAYERS': 'Custom Layers',
    'TAG_WIZARD.APPEARANCE.ITEM_INCLUDED': 'Item Included',
    'TAG_WIZARD.REVIEW.TEST_BUTTON_TEXT': 'TEST DATA: Export JSON Data',

    'TAG_WIZARD.PRINTABLE_SIDE.FRONT.ACTIVE_LABEL': 'Front',
    'TAG_WIZARD.PRINTABLE_SIDE.FRONT.ACTIVE_SUBLABEL': '(Included)',
    'TAG_WIZARD.PRINTABLE_SIDE.FRONT.INACTIVE_LABEL': 'Print Front',
    'TAG_WIZARD.PRINTABLE_SIDE.BACK.ACTIVE_LABEL': 'Back',
    'TAG_WIZARD.PRINTABLE_SIDE.BACK.ACTIVE_SUBLABEL': '(Optional)',
    'TAG_WIZARD.PRINTABLE_SIDE.BACK.INACTIVE_LABEL': 'Print Back',

    'TAG_WIZARD.REVIEW.HEADING': 'Review Tag',
    'TAG_WIZARD.REVIEW.DESCRIPTION':
        'Please review your tag design and quantity being ordered before adding it to your cart.',

    'TAG_WIZARD.PRICE_SUMMARY.HEADING': 'Price Summary',
    'TAG_WIZARD.PRICE_SUMMARY.TOTAL_PRICE': 'Total Price',

    'TAG_WIZARD.TAG_REVIEW.PIC_NOT_VERIFIED':
        'PROPERY/OWNER NAME REQUIRES MANUAL VERIFICATION',
    'TAG_WIZARD.TAG_REVIEW.PIC_NUMBER': 'PIC Number',
    'TAG_WIZARD.TAG_REVIEW.NAIT_NUMBER': 'NAIT Number',
    'TAG_WIZARD.TAG_REVIEW.FIRST_NAME': 'First Name',
    'TAG_WIZARD.TAG_REVIEW.LAST_NAME': 'Last Name',
    'TAG_WIZARD.TAG_REVIEW.BUSINESS_NAME': 'Business Name',
    'TAG_WIZARD.TAG_REVIEW.PROPERTY_NAME': 'Property Name',
    'TAG_WIZARD.TAG_REVIEW.OWNER_NAME': 'Owner Name',
    'TAG_WIZARD.TAG_REVIEW.INCLUDED_ITEM': 'Included Item',
    'TAG_WIZARD.TAG_REVIEW.MARKING_METHOD': 'Marking Method',
    'TAG_WIZARD.TAG_REVIEW.LAYOUT_VARIATION': 'Layout Variation',
    'TAG_WIZARD.TAG_REVIEW.CUSTOM_LIST': 'Custom List',
    'TAG_WIZARD.TAG_REVIEW.CUSTOM_FIELD': 'Custom Field',

    'TAG_WIZARD.TAG_REVIEW.TAG_PRODUCTION_TYPE': 'Tag Production Type',

    'TAG_WIZARD.TAG_REVIEW.BREEDER_POST_CODE': 'Breeder/Post Breeder Code',
    'TAG_WIZARD.TAG_REVIEW.PARTICIPANT_CODE': 'Participant Code',
    'TAG_WIZARD.TAG_REVIEW.YEAR_CODE': 'Year Code',
    'TAG_WIZARD.TAG_REVIEW.STARTING_NUMBER': 'Starting Number',
    'TAG_WIZARD.TAG_REVIEW.SEQUENCE_NUMBERS': 'Sequence Numbers',
    'TAG_WIZARD.TAG_REVIEW.PREFIX': 'Prefix',
    'TAG_WIZARD.TAG_REVIEW.DISEASE_CODE': 'Disease Code',
    'TAG_WIZARD.TAG_REVIEW.LOGO': 'LOGO',
    'TAG_WIZARD.TAG_REVIEW.STATE': 'State',
    'TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION_ISSUE_DATE':
        'DAF Authorisation Issue Date',
    'TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION_NUMBER':
        'DAF Authorisation Number',

    'TAG_WIZARD.TAG_REVIEW.CERTIFICATE_ISSUE_DATE': 'Certificate Issue Date',
    'TAG_WIZARD.TAG_REVIEW.CERTIFICATE_NUMBER': 'Certificate Number',
    'TAG_WIZARD.TAG_REVIEW.CERTIFICATE_QUANTITY': 'Certificate Quantity',

    'TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION': 'DAF Authorisation',
    'TAG_WIZARD.TAG_REVIEW.USE_BRAND_OVER_PIC': 'Brand Not PIC',
    'TAG_WIZARD.TAG_REVIEW.LAZY_LETTER': 'Lazy Letter',

    'TAG_WIZARD.TAG_REVIEW.YEAR': 'Year',
    'TAG_WIZARD.TAG_PRODUCTION_TYPE.YEAR': 'Tag Production Type',

    'TAG_WIZARD.TAG_REVIEW_MMT.MARKING_TYPE': 'Marking Type',
    'TAG_WIZARD.TAG_REVIEW_MMT.PIC_NUMBER': 'PIC Number',
    'TAG_WIZARD.TAG_REVIEW_MMT.PROPERTY_NAME': 'Property Name',
    'TAG_WIZARD.TAG_REVIEW_MMT.SEQUENCE_NUMBERS': 'Sequence Numbers',
    'TAG_WIZARD.TAG_REVIEW_MMT.PREFIX': 'Prefix',

    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.STYLE_OPTIONS': 'Style Options',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.TEXT_ALIGNMENT': 'Text Alignment',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.OBJECT_POSITION': 'Object Position',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.ROTATE': 'Rotate',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.FLIP': 'Flip',
    'TAG_WIZARD.SIDEMENU.MARKING_OPTIONS.ORIENTATION': 'Orientation',

    'TAG_WIZARD.LAYERS.CUSTOMER_MARKING': 'ADD CUSTOM MARKING',
    'TAG_WIZARD.LAYERS.LINE_TEXT': 'LINE',
    'TAG_WIZARD.LAYERS.EDITABLELAYERS': 'Editable Layers',
    'TAG_WIZARD.DROPZONE.DRAGTEXT': 'Drag file here or click to upload',
    'TAG_WIZARD.DROPZONE.SVGTEXT':
        'Please note: only SVG extension files will be accepted. Max Size: 3MB.',
    'TAG_WIZARD.MARKING.OPTIONS': 'Marking Options',
    'TAG_WIZARD.APPEARANCE.CUSTOM_TEXT':
        'Enter your custom text below. Text appears on the product image as you type, and can be resized and moved by clicking on the object or clicking and dragging handles. The font, alignment and styling can also be changed below.',

    'TAG_WIZARD.MARKING.TEXT.DESCRIPTION.DEFAULT':
        'Enter your custom text below. Text can be resized and moved around the tag by clicking and dragging handles. The font style, size, spacing and alignment can also be changed using the options below.',
    'TAG_WIZARD.MARKING.SEQUENCE.DESCRIPTION.DEFAULT':
        'Enter your start number below. To add a prefix, suffix or alter increments select the Advanced Options below. Your quantity will determine the last number.',
    'TAG_WIZARD.MARKING.LIST.DESCRIPTION.DEFAULT':
        'Type or paste a custom list into the field below. Each line will be printed on a separate tag. The font style, size, spacing and alignment can also be changed below to suit your requirements. When entering multiple lines the quantity of lines must match the quantity of tags you have ordered.',
    'TAG_WIZARD.MARKING.IMAGE.DESCRIPTION.DEFAULT':
        'Upload a logo or custom image by dragging your file directly onto the box below, or by clicking and searching for your file. The file format must be a black-and-white SVG file to match our laser printing requirements. You can also try <a target="_blank" href="https://convertio.co/jpg-svg/">www.convertio.co</a> to convert your current logo into the correct SVG format.',
    'TAG_WIZARD.MARKING.CODE.DESCRIPTION.DEFAULT':
        'Select your code type, such as barcode or QR code in the first field. Then enter the content for your code and see the preview appear on the product image. You can also activate sequence mode by ticking the box and following the prompts.',
    'TAG_WIZARD.MARKING.RFID.DESCRIPTION.DEFAULT':
        'Please note the image displayed is a depiction of how your tag will appear when marked. The actual RFID number cannot be determined until production has begun. During production, the tags are scanned by an RFID reader and the RFID number recorded. The recorded RFID number is then matched to and laser marked onto the tag.',
    'TAG_WIZARD.MARKING.RFID.OPTIONS.DEFAULT':
        'Select one of the marking options above to start.',

    'TAG_WIZARD.NAIT.IMAGE_ALERT': 'Example Only',

    // Credit Cards
    CARD_NAME: 'Card Name',
    CARD_NUMBER: 'Card Number',
    ADD_CREDIT_CARD: 'Add Card',
    ADD_NEW_CREDIT_CARD: 'Add New Card',

    // Customer Orders
    'CUSTOMER_ORDERS.RECENT_CUSTOMER_ORDERS.HEADING': 'Recent Customer Orders',
    'CUSTOMER_ORDERS.AWAITING_APPROVAL.HEADING': 'Awaiting Approval',
    'CUSTOMER_ORDERS.AWAITING_RESELLER_APPROVAL.HEADING':
        'Awaiting Reseller Approval',
    'CUSTOMER_ORDERS.APPROVED.HEADING': 'Approved',
    'CUSTOMER_ORDERS.BACK-ORDERED.HEADING': 'Back Orders',
    'CUSTOMER_ORDERS.REJECTED.HEADING': 'Rejected',
    'CUSTOMER_ORDERS.CUSTOMER_CONTACTED.HEADING': 'Contact Customer',
    'CUSTOMER_ORDERS.ON_ACCOUNT.HEADING': 'Awaiting Payment',
    'CUSTOMER_ORDERS.ON_ACCOUNT_PAYMENT_RECEIVED.HEADING': 'Payment Received',
    'CUSTOMER_ORDERS.ON_ACCOUNT_PAYMENT_SENT.HEADING': 'Payment Sent',

    APPROVAL_STATUS: 'Approval Status',

    // Checkout
    SELECT_ADDRESS: 'Select Address',
    SELECT_BILLING_ADDRESS: 'Select Billing Address',
    SELECT_DISPATCH_LOCATION: 'Select Dispatch Location',
    SELECT_DELIVERY_ADDRESS: 'Select Delivery Address',
    SELECT_DELIVERY_OPTION: 'Select Delivery Option',

    // React Table Remove Row
    REMOVE_ITEM_FROM_LIST: 'Remove item from list?',

    // Pagination
    NEXT: 'Next',
    PREV: 'Previous',

    // Common
    ALL: 'All',
    DISPATCH_STATUS: 'Dispatch Status',
    DELIVER_TO: 'Deliver To',
    NO_OF_ARTICLES: 'NO. ARTICLES',
    ADVANCED_OPTIONS: 'Advanced Options',
    APPROVE: 'Approve',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    BUYER_CONTACTED: 'Buyer Contacted',
    APPROVAL: 'Approval Status',
    CONTACT_CUSTOMER: 'Contact Customer',
    COST: 'Cost',
    BACK: 'Back',
    SHOW_MORE: 'Show More',
    CLOSE: 'Close',
    DEFAULT: 'Default',
    STATUS: 'Status',
    DATE: 'Date',
    ACTIVE_FILTERS: 'Active filters',
    CLEAR_ALL_FILTERS: 'Clear all filters',
    REFINE_RESULTS: 'Refine Results',
    'REFINE_RESULTS.MOBILE': 'Refine',
    'REFINE_RESULTS.DESKTOP': 'Refine Results',
    REFINE: 'Refine',
    RESULTS: 'results',
    AMOUNT: 'Amount',
    APPLY_FILTERS: 'Apply Filters',
    FILTER: 'Filter',
    DESCRIPTION: 'Description',
    CATEGORY: 'Category',
    ADD_CATEGORY: 'Add Category',
    SELECT_CATEGORY: 'Select Category',
    CREATE: 'Create',
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    CODE: 'Code',
    TYPE: 'Type',
    PRINT: 'Print',
    FROM: 'From',
    BUY_NOW: 'Buy Now',
    ON_SALE: 'On Sale',
    ADDRESS: 'Address',
    BILLING_ADDRESS: 'Billing Address',
    SHIPPING_ADDRESS: 'Shipping Address',
    PRICE: 'Price',
    UNIT_PRICE: 'Unit Price',
    EDIT: 'Edit',
    REMOVE: 'Remove',
    DELETE: 'Delete',
    SAVE: 'Save',
    SAVE_BANK_DETAILS: 'Save Bank Details',
    PAYFAST_SAVE__DETAILS: 'ADD PAYFAST ACCOUNT',
    SAVE_AND_CONTINUE: 'Save & Continue',
    SAVE_AND_CONTINUE_TO_STRIPE: 'Save & Continue To Stripe',
    SAVE_AND_CONTINUE_TO_PAYFAST: 'Save & Continue To PayFast',
    VIEW: 'View',
    VIEW_DETAILS: 'View details',
    'RESULT(S)': 'Result(s)',
    PRINT_PACKING_LABEL: 'Print Packing Label',
    NEXT_STEP: 'Next Step',
    RETRY: 'Retry',
    OR: 'Or',
    COUPON_COPY_CODE: 'Copy Code',
    PRODUCT_LIST_ITEM_LINK_TITLE_ID: 'Click to view all available colours',
    ENTER_ADDRESS_MANUALLY: 'Enter address manually',
    SOLD_BY: 'Sold By',
    ORDERED_BY: 'Ordered By',
    CONTAIN_TAGS: 'Contain Tags',
    CONTAINS: 'Contains',
    CARRIER: 'Carrier',
    EDIT_BANK_DETAILS: 'Edit Bank Details',
    EDIT_STRIPE_CONFIGURATION: 'Edit Stripe Configuration',
    VIEW_LOGS: 'View Logs',
    CREATE_NEW: 'Create New',
    VIEW_EDIT_DETAILS: 'View / edit details',
    DOWNLOAD: 'Download',
    N_A: 'N/A',
    MINIMUM_ORDER_QTY: 'Minimum order quantity',
    REF: 'REF',
    APPLY_CHANGES: 'Apply changes',
    FILTERS: 'Filters',
    DISPLAY: 'Display',
    PRODUCTS: 'Products',

    // REPORTS
    REPORTS_HEADING: 'Select a Report',
    REPORTS_GENERATE_REPORT: 'GENERATE REPORT',
    REPORTS_EXPORT_CSV: 'Export CSV',
    EXPORT: 'Export',

    // TABLE
    TABLE_NO_ITEMS_FOUND: 'No items found',
};

export default resources;
